<template>
  <div>
    <b-overlay
      variant="white"
      :show="submitting"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
    >
      <validation-observer ref="customerParameterDetailForm">
        <b-form ref="customerParameterDetailFormElement" class="" @submit.prevent="submit">
          <b-row>
            <b-col sm="6" lg="4">
              <b-form-group>
                <div class="d-flex form-group-label">
                  <label for="name">{{ t('Description') }}</label>
                  <span class="text-danger">*</span>
                </div>
                <validation-provider
                  #default="{ errors }"
                  :name="t('Description')"
                  rules="required"
                >
                  <b-form-input
                    id="description"
                    v-model="values.description"
                    name="description"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="t('Description')"
                    tabindex="3"
                    :readonly="type == 'edit'"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col sm="6" lg="4">
              <b-form-group>
                <div class="d-flex form-group-label">
                  <label for="name">{{ t('Value') }}</label>
                  <span class="text-danger">*</span>
                </div>
                <validation-provider #default="{ errors }" :name="t('Value')" rules="required">
                  <b-form-input
                    id="name"
                    v-model="values.value"
                    name="name"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="t('Value')"
                    tabindex="3"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col sm="6" lg="4">
              <b-form-group>
                <div class="d-flex form-group-label">
                  <label for="name">{{ t('Key') }}</label>
                  <span class="text-danger">*</span>
                </div>
                <validation-provider #default="{ errors }" :name="t('Key')" rules="required">
                  <b-form-input
                    id="key"
                    v-model="values.key"
                    name="key"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="t('Key')"
                    tabindex="3"
                    :readonly="type == 'edit'"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col sm="6" lg="4">
              <b-form-group>
                <div class="d-flex form-group-label">
                  <label for="name">{{ t('Type') }}</label>
                  <span class="text-danger">*</span>
                </div>
                <validation-provider #default="{ errors }" :name="t('Type')" rules="required">
                  <b-form-input
                    id="type"
                    v-model="values.type"
                    name="type"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="t('Type')"
                    tabindex="3"
                    :readonly="type == 'edit'"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-button
                variant="primary"
                class="mt-1 d-flex align-items-center"
                type="submit"
                tabindex="11"
              >
                {{
                  submitting
                    ? t('Please Wait')
                    : type === 'new'
                    ? t('Add New Parameter')
                    : t('Edit')
                }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-overlay>
  </div>
</template>
<script>
import { BCol, BForm, BFormGroup, BFormInput, BRow, BButton, BOverlay } from 'bootstrap-vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { helper } from '@core/mixins/helper';

export default {
  components: {
    BOverlay,
    BButton,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BForm,

    ValidationObserver,
    ValidationProvider
  },

  mixins: [helper],
  props: {
    type: {
      type: String,
      default: 'new'
    },
    submitting: {
      type: Boolean,
      default: false
    },
    values: {
      type: Object,
      default() {
        return {
          description: '',
          value: '',
          key: '',
          type: ''
        };
      }
    }
  },
  data() {
    return {
      statusTypeOptions: []
    };
  },

  computed: {},

  methods: {
    submit() {
      this.$refs.customerParameterDetailForm.validate().then(success => {
        if (success) {
          this.$emit('submit', {
            ...this.values
          });
        }
      });
    },

    resetForm() {
      this.$refs.customerParameterDetailFormElement.reset();
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
